import { render } from "./BatchNotes.vue?vue&type=template&id=d9d901ee&scoped=true"
import script from "./BatchNotes.vue?vue&type=script&lang=js"
export * from "./BatchNotes.vue?vue&type=script&lang=js"

import "./BatchNotes.vue?vue&type=style&index=0&id=d9d901ee&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9d901ee"]])

export default __exports__